import shipaidLogo from '../assets/icons/shipaid.png';
import classes from '../modulecss/trackingFooter.module.css';

const TrackingFooter = () => {
  return (
    <div className={classes.container}>
      <img
        src={shipaidLogo}
        alt="logo"
        style={{ height: 'auto', width: '50px' }}
      />
    </div>
  );
};

export default TrackingFooter;
